// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__2QU32","topBottomGutter":"Layout_topBottomGutter__1ykNg"};